import { render, staticRenderFns } from "./NewsSystemicoSection.vue?vue&type=template&id=75fddd46&scoped=true"
import script from "./NewsSystemicoSection.vue?vue&type=script&lang=js"
export * from "./NewsSystemicoSection.vue?vue&type=script&lang=js"
import style0 from "./NewsSystemicoSection.vue?vue&type=style&index=0&id=75fddd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fddd46",
  null
  
)

export default component.exports